import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div\n  class=\"eat-motion-indicator {{if this.motionService.isAnimating \"active\"}}\"\n  ...attributes\n/>")